import React, { createContext, useEffect, useState } from 'react'

type ScrollLockContextProps = {
  requestScrollLock: (id: string) => void
  releaseScrollLock: (id: string) => void
}

export const ScrollLockContext = createContext<ScrollLockContextProps>({
  requestScrollLock: () => {},
  releaseScrollLock: () => {},
})

type Props = {
  children: React.ReactNode
}

export const ScrollLockProvider = ({ children }: Props) => {
  const [modals, setModals] = useState<string[]>([])

  const requestScrollLock = (id: string) => {
    setModals(prevModals =>
      !prevModals.find(_id => id === _id) ? [...prevModals, id] : prevModals
    )
  }

  const releaseScrollLock = (id: string) => {
    setModals(prevModals => prevModals.filter(_id => id !== _id))
  }

  useEffect(() => {
    if (modals.length > 0) {
      setBodyPadding()
      document.documentElement.classList.add('disable-scroll')
    } else {
      clearBodyPadding()
      document.documentElement.classList.remove('disable-scroll')
    }

    return () => {
      document.documentElement.classList.remove('disable-scroll')
    }
  }, [modals])

  const setBodyPadding = () => {
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
    document.body.style.paddingRight = `${scrollBarWidth}px`
  }

  const clearBodyPadding = () => {
    document.body.style.paddingRight = `0px`
  }

  return (
    <ScrollLockContext.Provider value={{ requestScrollLock, releaseScrollLock }}>
      {children}
    </ScrollLockContext.Provider>
  )
}
